import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import useDocumentTitle from '../../../components/useDocumentTitle';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { DeleteLazyPost, SingleLazyPostDetails } from '../../../hooks/LazyMinting';
import { fetchEthPriceToUSDT } from '../../../hooks/Tokenhook';
import { ToastContainer, toast } from 'react-toastify';
import { ethers, toBigInt } from 'ethers';
import { collectionABI } from '../../../config/ABIs/CollectionABI';
import { useSelector } from 'react-redux';
import { FaRegCirclePlay } from 'react-icons/fa6';
import { SingleUserDetails } from '../../../hooks/User';

const ItemDetails = () => {
  const ref = useRef();
  const closeTooltip = () => ref.current.close();
  const [nft, setNft] = useState(null);
  const [prize, setPrize] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [priceInDoller, setpriceInDoller] = useState(0);
  const [user, setUser] = useState(null);

  const { id } = useParams();
  const router = useNavigate();
  const walletAddress = localStorage.getItem("WalletAddress");
  const PROVIDER = useSelector((state) => state.valueFromHeader);


  useEffect(() => {
    SingleLazyPostDetails(id).then(async (data) => {
      if (data.status === 200) {
        setNft(data.data[0])
        const LazyData = data.data[0];
        const priceUSDT = await fetchEthPriceToUSDT(LazyData?.price)
        setpriceInDoller(priceUSDT);
        if (LazyData.userId) {
          const UserData = await SingleUserDetails(LazyData.userId)
          console.log("User", UserData);
          if (UserData.status === 200) {
            setUser(UserData.user)
          }
        }
      }
    })
  }, [id]);

  async function buyNft(nft) {
    if (!walletAddress) {
      toast.error("Please connect Wallet first !!!")
    }
    else {
      const wallet = await PROVIDER.getSigner();
      const contract = new ethers.Contract(
        nft.contractAddress,
        collectionABI,
        wallet
      );

      //  user will be prompted to pay the asking proces to complete the transaction
      const priceInWei = ethers.parseEther(prize);
      const Signature = [priceInWei, nft.tokenURI, nft.signature[0], toBigInt(nft.royaltyFraction)];

      await contract.lazyMint(
        Signature,
        {
          value: priceInWei,
        }).then((a) => {
          toast.success("Transaction successful !!!")
          router.push("/marketplace")
          DeleteLazyPost(nft._id).then((data) => {
            console.log("data", data);
          })
        }).catch((e) => {
          console.log("eeee=>", e)
        });
    }
  };
  console.log("log", user);

  useDocumentTitle('Item Details');
  return (
    <div>
      <div className="container">
        <Link to="/home-1" className="btn btn-white btn-sm my-40">
          Back to home
        </Link>
        <div className="item_details">
          {nft !== null &&
            <div className="row sm:space-y-20">
              <div className="col-lg-6">
                <div className="card_head">
                  {nft.type?.split("/")[0] !== "image" ? (
                    <div
                      className="video-wrapper"
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                    >
                      <video
                        style={{ borderRadius: "18px" }}
                        muted
                        loop
                        playsInline
                        className={`video ${isHovered ? "playing" : ""}`}
                        onMouseEnter={(e) => e.target.play()}
                        onMouseLeave={(e) => e.target.pause()}
                      >
                        <source src={nft.image} type={nft.type} />
                        Your browser does not support the video tag.
                      </video>
                      {!isHovered && <div className="pause-overlay"><FaRegCirclePlay /></div>}
                    </div>
                  ) : (
                    <img
                      src={nft.image}
                      alt={`Preview ${nft.type}`}
                      style={{ borderRadius: "18px" }}
                    />
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="space-y-20">
                  <div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div>
                        <div className='d-flex'>

                          <h3 style={{ whiteSpace: "nowrap" }}>{nft && nft.title}</h3>
                          <p className='mx-2'>{`(${nft && nft.category})`}</p>
                        </div>
                        {user !== null &&
                          <div className='d-flex'>
                            <p className='pt-2'>
                              own by
                            </p>
                            <div className="mx-2 d-flex align-items-end">
                              <Link to={user.walletAddress}>
                                <img
                                  src={user.profilePicture}
                                  alt="Creator"
                                  style={{
                                    borderRadius: "50%",
                                    width: 32,
                                    height: 32
                                  }}
                                // onError={handleError}
                                />
                              </Link>
                              <Link to={user.walletAddress}>
                                <p className="avatars_name mx-2 txt_sm" style={{whiteSpace:"nowrap"}}>{user.name || "Unknown"}</p>
                              </Link>
                            </div>

                          </div>
                        }
                      </div>
                      <div className="nft_details_2 my-40">
                        <div className="nft_rank" style={{ whiteSpace: "nowrap" }}>
                          Royality: {nft?.royaltyFraction / 100} %
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="box">
                    <Tabs className="space-y-20">
                      <div className="d-flex justify-content-between mb-30_reset">
                        <TabList className="d-flex space-x-10 mb-30 nav-tabs">
                          <Tab className="nav-item">
                            <Link
                              className="btn btn-white btn-sm"
                              data-toggle="tab"
                              to="#tabs-1"
                              role="tab">
                              Details
                            </Link>
                          </Tab>

                        </TabList>

                      </div>
                      <div className="hr" />
                      <div className="tab-content">
                        <TabPanel className="active">
                          <p>
                            {nft && nft.desc}
                          </p>
                        </TabPanel>
                      </div>
                    </Tabs>
                  </div>
                  <div className="numbers">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="space-y-5">
                          <p className="color_text">Price</p>
                          <h4>
                            {nft && nft.price}
                            <span className="txt_sm color_text mx-1">
                              ETH/ $ {priceInDoller}
                            </span>
                          </h4>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="space-y-5">
                          <p className="color_text">Listed</p>
                          <div className="txt_lg _bold">
                            {nft && nft.listed ? "Listed" : "Not Listed"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="hr2" />
                  <div className="d-flex space-x-20">
                    {nft !== null ? nft.walletAddress !== walletAddress &&
                      <Popup
                        className="custom"
                        ref={ref}
                        trigger={
                          <button className="btn btn-lg btn-primary" >
                            Buy Now
                          </button>
                        }
                        position="bottom center">
                        <div>
                          <div
                            className="popup"
                            id="popup_bid"
                            tabIndex={-1}
                            role="dialog"
                            aria-hidden="true">
                            <div>
                              <button
                                type="button"
                                className="button close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={closeTooltip}>
                                <span aria-hidden="true">×</span>
                              </button>
                              <div className="space-y-20">
                                <h3>Buy NFT</h3>
                                <p>
                                  You are about to purchase a
                                  <span className="color_black mx-2">{nft && nft.title}</span>
                                </p>
                                <div className="space-y-10">
                                  <p>You pay</p>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="00.00 ETH"
                                    onChange={(e) => setPrize(e.target.value)}
                                  />
                                </div>
                                <div className="hr" />
                                <div className="d-flex justify-content-between">
                                  <p> You must bid at least:</p>
                                  <p className="text-right color_black txt _bold">
                                    {nft && nft.price} ETH
                                  </p>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <p> service free:</p>
                                  <p className="text-right color_black txt _bold">
                                    0 ETH
                                  </p>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <p> Total bid amount:</p>
                                  <p className="text-right color_black txt _bold">
                                    {nft && nft.price} ETH
                                  </p>
                                </div>
                                <button
                                  to="404"
                                  className="btn btn-primary
                                                      w-full"
                                  aria-label="Close"
                                  onClick={() => buyNft(nft)}
                                >
                                  Buy NFT
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Popup>
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default ItemDetails;
